module.exports = __webpack_public_path__ + "static/media/icon-umaCare.03d4ffa6.svg";